import React from 'react';

type UnsavedChangesModalProps = {
  show: boolean;
  message?: string;
  onDiscard: () => void;
  onKeepEditing: () => void;
};

/** Bootstrap Modal puro — patrón Admin (sin window.confirm). */
function UnsavedChangesModal({
  show,
  message = 'You have unsaved changes. Discard them?',
  onDiscard,
  onKeepEditing,
}: UnsavedChangesModalProps) {
  if (!show) return null;

  return (
    <div
      className="modal fade show"
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-body text-center">
            <p className="mb-0">{message}</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button type="button" className="btn btn-outline-secondary" onClick={onKeepEditing}>
              Keep editing
            </button>
            <button type="button" className="btn btn-outline-danger" onClick={onDiscard}>
              Discard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnsavedChangesModal;
